var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Linked S&R Requirements")]),_c('requirement-search-result-panels',{attrs:{"search-result":_vm.searchResult}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }